import {adminAPI} from '../util/Api';
import {
    EOD_INIT,
    FETCH_ERROR,
    FETCH_START,
    FETCH_SUCCESS,
    EOD_SNAPSHOT,
    EOD_SNAPSHOT_DENOM
} from "../constants/ActionTypes";


export const eodInit = () => {
    return {
        type: EOD_INIT
    }
};


export const getEodsnapshotList = (params) => {
    //Get denominations list from Admin API

    let token = sessionStorage.getItem('token');

    const opts = {
        params: params,
        headers: {
            'content-type': 'application/json',
            'accept': 'application/json',
             Authorization: `Bearer ${token}`,
        }
    }
    
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        adminAPI.get('eodsnapshot', opts
        ).then(({ data }) => {
            if (data) {
                dispatch({ type: FETCH_SUCCESS });
                // format data and store them for use..
                dispatch({ type: EOD_SNAPSHOT, payload: data });
            } else {
                dispatch({ type: FETCH_ERROR, payload: data.error });
            }
        }).catch((error) => {
            dispatch({ type: FETCH_ERROR, payload: error.message });
        });
    }
}


export const getEodsnapshotDenom = (params) => {
    //Get denominations list from Admin API

    let token = sessionStorage.getItem('token');
   
    const opts = {
        params: params,
        headers: {
            'content-type': 'application/json',
            'accept': 'application/json',
             Authorization: `Bearer ${token}`,
        }
    }
    return async (dispatch) => {
        dispatch({ type: FETCH_START });
        await adminAPI.get('eodsnapshotdenominations', opts
        ).then(({ data }) => {
            if (data) {
                dispatch({ type: FETCH_SUCCESS });
                // format data and store them for use..
                dispatch({ type: EOD_SNAPSHOT_DENOM, payload: data });
            } else {
                dispatch({ type: FETCH_ERROR, payload: data.error });
            }
        }).catch((error) => {
            dispatch({ type: FETCH_ERROR, payload: error.message });
        });
    }
}
